var map = {
	"./cerrar.svg": 5858,
	"./correo.svg": 9493,
	"./facebook.svg": 1420,
	"./instagram.svg": 6629,
	"./logo.svg": 1162,
	"./menul.svg": 2402,
	"./next-arrow-primary.svg": 6693,
	"./next-arrow.svg": 4752,
	"./phone.svg": 6529,
	"./pin.svg": 72,
	"./prev-arrow-primary.svg": 1874,
	"./prev-arrow.svg": 6640,
	"./whatsapp-success.svg": 719,
	"./whatsapp.svg": 5001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3027;